<template>
  <div>
    <h1 class="text-center mt-10">{{ $t('pageEnd.header') }}</h1>
    <p class="text-center text">{{ $t('pageEnd.paragraph1') }}&nbsp;</p>
    <p class="text-center text">{{ text.paragraph2 }}&nbsp;</p>
    <p class="text-center note">{{ this.user.config.parameters.parameters.customconfirmationaddition }}&nbsp;</p>
    <p v-if="appointment && showEasyRentAppointmentError(appointment)" class="text-center text">
      {{ $t('pageEnd.easyrent_contracterror') }}&nbsp;
      <a :href="'tel:' + this.user.department.phone">{{ this.user.department.phone }}</a>
    </p>
    <pre v-if="appointment" style="display: none">{{ appointment }}</pre>
    <Loader v-if="this.user.loading" />
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import localizationTexts from '@/localization/texts.json';
import helpers from '@/settings/helpers';
const { mapGetters } = createNamespacedHelpers('user');
const { mapGetters: appointmentGetters } = createNamespacedHelpers('appointment');

export default Vue.extend({
  name: 'End',
  components: {
    Loader
  },
  data() {
    return {
      text: {
        paragraph2: ''
      }
    };
  },
  beforeMount() {
    if (this.user.step === 0) {
      this.$router.push({ name: 'Home' });
    }
    if (this.user.step === 1) {
      this.$router.push({ name: 'Service' });
    }
    if (this.user.step === 2) {
      this.$router.push({ name: 'Appointment' });
    }
    if (this.user.step === 3) {
      this.$router.push({ name: 'Customer' });
    }
    if (this.user.step === 4) {
      this.$router.push({ name: 'Confirmation' });
    }
  },
  mounted() {
    helpers.sendScroll(this.user.config.container, 0, this.user.config.host);
    this.text.paragraph2 = localizationTexts[this.user.config.language].pageEnd.paragraph2
      .replace('#DATE#', new Date(this.user.datetime.date).getDate() + '/' + Math.floor(new Date(this.user.datetime.date).getMonth() + 1))
      .replace('#TIME#', this.user.datetime.arrival.text)
      .replace('#ADDRESS#', this.user.department.address)
      .replace('#ZIPCODE#', this.user.department.zipcode)
      .replace('#CITY#', this.user.department.city);
  },
  methods: {
    showEasyRentAppointmentError(appointment) {
      if (appointment && appointment.messages) {
        const hasError = !!appointment.messages.find((x) => x.iserror && x.messagetype == 'EasyRent');
        return hasError;
      }
      return false;
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...appointmentGetters(['appointment'])
  }
});
</script>

<style scoped lang="scss">
.text-center {
  padding: 5px 0;
}
.text {
  font-size: 1.125rem;
}
.note {
  font-size: 1rem;
  font-weight: 700;
}
</style>

<i18n src="../localization/texts.json"></i18n>
